import type { ExperienceDetails } from '@atlassian/jira-business-experience-tracking/src/types.tsx';

const PACKAGE_NAME = 'jiraBusinessHorizontalNav';

export const VIEW_NAV_EXPERIENCE: ExperienceDetails = {
	experience: 'view-horizontal-nav',
	packageName: PACKAGE_NAME,
	teamName: 'wanjel',
};

export const VIEW_HORIZONTAL_NAVIGATION_EXPERIENCE: ExperienceDetails = {
	experience: 'viewHorizontalNavigation',
	packageName: PACKAGE_NAME,
	teamName: 'wanjel',
};

// Analytics constants
export const CONTAINER = 'container';
export const PROJECT = 'project';
export const TAB = 'tab';
